/**
 * @generated SignedSource<<83ffbd26d741a58ad45659d48bc91a35>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DaylightSavingTimeChange = "NONE" | "SUMMER_TIME_TO_WINTER_TIME" | "WINTER_TIME_TO_SUMMER_TIME";
import { FragmentRefs } from "relay-runtime";
export type appointmentsTable_waitingRoomDay$data = ReadonlyArray<{
  readonly date: any;
  readonly id: string;
  readonly slots: ReadonlyArray<{
    readonly appointments: ReadonlyArray<{
      readonly appointment: {
        readonly appointmentId: number;
        readonly id: string;
        readonly patient: {
          readonly birthDate: any;
          readonly displayId: number;
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
          readonly patientId: string;
        };
        readonly reason: string;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"appointmentRowPatient_WaitingRoomAppointment" | "appointmentRow_WaitingRoomAppointment">;
    }>;
    readonly id: string;
    readonly slotId: number;
    readonly timeChangeStatus: DaylightSavingTimeChange;
  }>;
  readonly " $fragmentType": "appointmentsTable_waitingRoomDay";
}>;
export type appointmentsTable_waitingRoomDay$key = ReadonlyArray<{
  readonly " $data"?: appointmentsTable_waitingRoomDay$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentsTable_waitingRoomDay">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "appointmentsTable_waitingRoomDay",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitingRoomSlot",
      "kind": "LinkedField",
      "name": "slots",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slotId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeChangeStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitingRoomAppointment",
          "kind": "LinkedField",
          "name": "appointments",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "appointmentRowPatient_WaitingRoomAppointment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "appointmentRow_WaitingRoomAppointment"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Appointment",
              "kind": "LinkedField",
              "name": "appointment",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appointmentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reason",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "patient",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "patientId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "birthDate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomDay",
  "abstractKey": null
};
})();

(node as any).hash = "25f922fcd3f0eeb279958d458138fe1f";

export default node;
